import { apiClient } from '~/services/api-service';
import {
  DynamicQrCodeData,
  QrCodesListResponse,
  QrCodeStylesResponse,
  StaticQrCodeData,
  UpdateQrCodeDataPayload,
} from '~/types/qrCode';

export const qrcodeAPIService = {
  getListOfQrCodes: (params) => {
    const queries = new URLSearchParams(params).toString();
    return apiClient.get<QrCodesListResponse>(`/qrcode/?${queries}`);
  },
  getQrCodeStyles: () => {
    return apiClient.get<QrCodeStylesResponse>('/qrcode/styles/');
  },
  getQrCodeByURI: ({ id, password }: { id: number | string; password?: string }) => {
    return apiClient.post(`/qrcode/s/${id}/`, { password });
  },
  getQrCodeById: (id: number | string) => {
    return apiClient.get<DynamicQrCodeData | StaticQrCodeData>(`/qrcode/${id}/`);
  },
  createQrCode: (body) => {
    return apiClient.post('/qrcode/', body);
  },
  updateQrCode: (body: UpdateQrCodeDataPayload, id: number | string) => {
    return apiClient.patch(`/qrcode/${id}/`, body);
  },
  getUriValidation: (uri: string, signal?: AbortSignal) => {
    const searchParams = new URLSearchParams();
    searchParams.set('uri', uri);
    return apiClient.get(`/qrcode/validate_uri/?${searchParams.toString()}`, { signal });
  },
  downloadSingleQrCode: ({ id, format }, params) => {
    return apiClient.get(`/qrcode/download-qr/${id}/${format}`, params); // strange backend here we do not need / in the end
  },
  downloadGroupOfQrCodes: (params, headers) => {
    return apiClient.post('/qrcode/download-qrs/', params, headers);
  },
  removeQrCodes: (ids) => {
    return apiClient.post('/qrcode/bulk-delete/', ids);
  },
  activateQrCodes: (ids) => {
    return apiClient.post('/qrcode/bulk-activate/', ids);
  },
  deactivateQrCodes: (ids) => {
    return apiClient.post('/qrcode/bulk-deactivate/', ids);
  },
  linkQrCodeToUser: (id: number | string, body) => {
    return apiClient.post(`/qrcode/${id}/link-user/`, body);
  },

  // Static

  changeStaticQrType: ({ id, type, body }) => {
    return apiClient.post(`/qrcode/static/${id}/change_type/${type}/`, body);
  },

  // Static qrcode URL
  createStaticQrUrl: ({ body }) => {
    return apiClient.post('/qrcode/static/url/', body);
  },
  updateStaticQrUrl: ({ body, id }) => {
    return apiClient.patch(`/qrcode/static/url/${id}/`, body);
  },
  deleteStaticQrUrl: ({ id }) => {
    return apiClient.delete(`/qrcode/static/url/${id}/`);
  },

  // Static qrcode TEXT
  createStaticQrText: ({ body }) => {
    return apiClient.post('/qrcode/static/text/', body);
  },
  updateStaticQrText: ({ body, id }) => {
    return apiClient.patch(`/qrcode/static/text/${id}/`, body);
  },
  deleteStaticQrText: ({ id }) => {
    return apiClient.delete(`/qrcode/static/text/${id}/`);
  },

  // Static qrcode WIFI
  createStaticQrWifi: ({ body }) => {
    return apiClient.post('/qrcode/static/wifi/', body);
  },
  updateStaticQrWifi: ({ body, id }) => {
    return apiClient.patch(`/qrcode/static/wifi/${id}/`, body);
  },
  deleteStaticQrWifi: ({ id }) => {
    return apiClient.delete(`/qrcode/static/wifi/${id}/`);
  },

  // Static qrcode EMAIL
  createStaticQrEmail: ({ body }) => {
    return apiClient.post('/qrcode/static/email/', body);
  },
  updateStaticQrEmail: ({ body, id }) => {
    return apiClient.patch(`/qrcode/static/email/${id}/`, body);
  },
  deleteStaticQrEmail: ({ id }) => {
    return apiClient.delete(`/qrcode/static/email/${id}/`);
  },

  // Static qrcode SMS
  createStaticQrSms: ({ body }) => {
    return apiClient.post('/qrcode/static/sms/', body);
  },
  updateStaticQrSms: ({ body, id }) => {
    return apiClient.patch(`/qrcode/static/sms/${id}/`, body);
  },
  deleteStaticQrSms: ({ id }) => {
    return apiClient.delete(`/qrcode/static/sms/${id}/`);
  },

  // Static qrcode WhatsApp
  createStaticQrWhatsapp: ({ body }) => {
    return apiClient.post('/qrcode/static/whatsapp/', body);
  },
  updateStaticQrWhatsapp: ({ body, id }) => {
    return apiClient.patch(`/qrcode/static/whatsapp/${id}/`, body);
  },
  deleteStaticQrWhatsapp: ({ id }) => {
    return apiClient.delete(`/qrcode/static/whatsapp/${id}/`);
  },
  // Static qrcode V-CARD
  createStaticQrVCard: ({ body }) => {
    return apiClient.post('/qrcode/static/vcard/', body);
  },
  updateStaticQrVCard: ({ body, id }) => {
    return apiClient.patch(`/qrcode/static/vcard/${id}/`, body);
  },
  deleteStaticQrVCard: ({ id }) => {
    return apiClient.delete(`/qrcode/static/vcard/${id}/`);
  },
};
